module.exports = __webpack_public_path__ + "media/images/curly-line-main-012ec460d7bd890d29d4d53087255faf.svg";